/*----------------------------------
- SUPPORT
----------------------------------*/

/**
 * Permanent booking link used by the "Book a call with our team" action.
 *
 * This is intentionally a hosted booking page so Client users can schedule a conversation without
 * receiving an individual link from the team first. Leave it empty to keep chat and email as the
 * only support channels.
 */
export const SUPPORT_BOOKING_URL = 'https://calendly.com/jordan-crosspath/introcall';

/** Booking page of the CrossPath team member who talks to prospective BD partners (Campus "Become a BD partner"). */
export const BD_PARTNER_BOOKING_URL = 'https://calendly.com/mayssa-crosspath/30min';

/** Shared support fallback for users who do not have an active client subscription. */
export const SUPPORT_EMAIL = 'hello@becrosspath.com';

/** Meeting length advertised on the Help page — keep in sync with the Calendly event. */
export const SUPPORT_BOOKING_DURATION_MINUTES = 30;

/** Canonical in-app Help Desk section inside Account Details. */
export const SUPPORT_HELP_DESK_PATH = '/dashboard/account-details#settings-help';

export const hasSupportBooking = (): boolean => SUPPORT_BOOKING_URL.trim().length > 0;

type SubscriptionSummary = {
    subscription?: {
        status?: {
            state?: string | null;
        } | null;
    } | null;
};

/**
 * Calls are a benefit for accounts that appear as Active in the CRM Clients subscription view.
 * Role is intentionally not part of this condition: one account can also carry internal roles.
 */
export const canBookSupportCall = (account?: SubscriptionSummary | null): boolean =>
    account?.subscription?.status?.state === 'active';

export const getSupportEmailUrl = (subject: string): string =>
    `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}`;

/** Marks the one-time "there is support here" dot on the header entry point as seen. */
export const HELP_HINT_STORAGE_KEY = 'crosspath.helpSupportHintSeen';

/** Event the Help entry points fire to open the global chat widget rendered in the layout. */
export const OPEN_CHAT_EVENT = 'crosspath:open-chat';

export const openSupportChat = (): void => {
    window.dispatchEvent(new CustomEvent(OPEN_CHAT_EVENT));
};
